import React from 'react';
import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import configureStore, { history } from './store';
import App from './containers/App';
import { LoadScript } from '@react-google-maps/api';
export const store = configureStore();

const MainApp = () => (
	<Provider store={store}>
		<LoadScript
			googleMapsApiKey="AIzaSyA7CMDOu9gdiUld9SOwQZntjOnpbTiguWc" //"AIzaSyAolLUIFn7E3dXKePISejM4TszkBkTl_1o"
			libraries={['places', 'geometry', 'drawing', 'visualization']}
			onLoad={() => console.log('MAPS LOADED')}
		>
			<ConnectedRouter history={history}>
				<Switch>
					<Route path="/" component={App} />
				</Switch>
			</ConnectedRouter>
		</LoadScript>
	</Provider>
);

export default MainApp;



// WEBPACK FOOTER //
// ./MainApp.js